// frontend/src/main.tsx - DEBUG VERSION
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

console.log('🔥 main.tsx is executing!');

const rootElement = document.getElementById('root');
console.log('🔥 Root element:', rootElement);

if (!rootElement) {
  console.error('❌ No root element found!');
} else {
  console.log('✅ Root element found, creating React root...');
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('✅ React root created, rendering App...');
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
    
    console.log('✅ App rendered successfully!');
  } catch (error) {
    console.error('❌ Error creating React root or rendering:', error);
  }
}
